module.exports = __webpack_public_path__ + "media/images/icons/edit-70519f130969b3badd72e712ae9b678e.svg";